import { breakpoints, windowWidth } from "./config";

/**
 * Init GPT on the page.
 * @returns {Object} googletag. Either the GPT instance loaded on the page, or an object on the window with 1 method, CMD.
 * This is the recommended way to use this, as GPT when loaded will check the CMD array and run through its queue, so it can be used async.
 */
export function initGam() {
  window.googletag = window.googletag || {};
  var googletag = window.googletag;
  googletag.cmd = googletag.cmd || [];

  googletag.cmd.push(function () {
    googletag.pubads().disableInitialLoad();
  });

  return googletag;
}

/**
 * Determine the breakpoint.
 * @returns {String} breakpoint. The detected breakpoint. Mobile, tablet, or desktop.
 */
export function determineBreakpoint() {
  let breakpoint = null;

  if (windowWidth > breakpoints.desktop) {
    breakpoint = "desktop";
  } else if (windowWidth >= breakpoints.tablet) {
    breakpoint = "tablet";
  } else {
    breakpoint = "mobile";
  }

  return breakpoint;
}

/**
 * Returns the detected layout to determine which ads to load on the page.
 */
export function determineLayout() {
  if (window.drupalSettings && window.drupalSettings.ads) {
    return window.drupalSettings.ads.layout;
  } else {
    return "no layout";
  }
}

/**
 * Util to get a value out of a cookie
 */
export function getCookieValue(key) {
  let cookies = document.cookie.split("; ");
  for (let i = 0, parts; (parts = cookies[i] && cookies[i].split("=")); i++) {
    if (decode(parts.shift()) === key) {
      return decode(parts.join("="));
    }
  }
  return null;
}

function decode(s) {
  return decodeURIComponent(s.replace(/\+/g, " "));
}

export function ajaxEventHandler() {
  // This will fire after every ajax event. We then check it for only the events we want to fire on - using the URL structure along with /ajax/.
  // Then we refresh the two ads that are located inside the ajax replaced DOM elements.
  $(document).ajaxComplete(function (event, xhr, settings) {
    // Tracker is all the tracker (recent, top, etc) forums, forums is the main taxonomies, views/ajax is pagination.
    const ajaxEvents = ["/ajax/tracker/", "/ajax/forum/", "/views/ajax?"];

    // Check the URL of the ajax event to make sure it's an event related to the view container changing.
    if (settings && ajaxEvents.some((event) => settings.url.includes(event))) {
      const slots = window.googletag.pubads().getSlots();
      const bannerOne = slots.find(
        (x) =>
          x.getAdUnitPath() === "/21841313772,22653506037/wso/forum_banner_1"
      );
      const bannerTwo = slots.find(
        (x) =>
          x.getAdUnitPath() === "/21841313772,22653506037/wso/forum_banner_2"
      );

      // Only refresh the two units that are in the ajax-replaced elements.
      if (bannerOne && bannerTwo) {
        window.googletag.cmd.push(function () {
          window.googletag.pubads().refresh([bannerOne, bannerTwo]);
        });
      }
    }
  });
}
